import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is cross-platform app development?",
    answer: `<p>Cross-platform mobile app development is the process of developing software apps that operate smoothly across different platforms and devices. Cross-platform development enable developers to use a single codebase that can be deployed on different platforms.</p>`,
  },
  {
    question: "How do Cross Platform Apps Work?",
    answer: ` <p>Cross-Platform app development allows you to publish an app on multiple platforms through a single codebase, instead of having to develop the app in each platform’s native language and technology.</p>`,
  },
  {
    question: "How much does cross-platform app development cost?",
    answer: `<p>The cost of cross-platform app development is based on multiple elements such as the app’s complexity, functionality, design, features, number of supported platforms, and much more. However, the estimated cost of cross-platform app development ranges from $20,000 to $65,000.</p>`,
  },
  {
    question: "What is the market share of cross-platform development?",
    answer: `<p>In 2023, the global market for Cross-Platform App Development Framework reached a valuation of around US$ 120 billion. The market is likely to grow at a CAGR of 16.7% over the next five years and will reach an estimated value of $546.7 billion by 2033. </p>`,
  },
  {
    question: "How long does cross-platform app development take?",
    answer: ` <p>The timeline for developing cross-platform apps typically spans 3 to 6 months, depending upon various factors. This estimate is subject to variables like development complexity and the clarity of defined functionalities, making it crucial to consider project specifics for a more accurate assessment.</p>`,
  },
  {
    question: "What is the main benefit of cross-platform development?",
    answer: ` <p>The main benefit of cross-platform development is its cost-effectiveness and streamlined efficiency. Through a unified codebase, developers can seamlessly deploy apps across diverse OS, reducing both development time and costs.</p>`,
  },
  {
    question: "Is cross-platform app development the future?",
    answer: `<p>Yes, cross-platform app development is increasingly recognized as the future of mobile app development. In the evolving landscape of technology, frameworks like Flutter, React Native, and others are poised to be pivotal, promising improved performance and expanded access to native APIs.</p>`,
  },
  {
    question:
      "Is it possible to integrate third-party services into cross-platform apps?",
    answer: `<p>Yes, cross-platform apps can seamlessly integrate third-party services. The flexibility of frameworks like Flutter, React Native, and others allows developers to integrate various APIs, SDKs, and third-party services for features such as payment gateways, social media integration, analytics, and more.</p>`,
  },
  {
    question:
      "Why choose TekRevol for cross-platform mobile app development services?",
    answer: `<p>TekRevol expert in harnessing profound expertise to craft cross-platform apps that not only meet but surpass business expectations. Our adept developers harness cutting-edge technology, embracing a holistic approach covering strategy, engineering, optimization, testing, and post-launch maintenance. Entrust us with your project, and rest assured, your product will be intricately tailored for unequivocal success.</p>`,
  },
  {
    question: "What is the most used cross-platform mobile development?",
    answer: `<p>There are many frameworks available for cross-platform mobile app development, with leading options including Flutter, React Native, Kotlin, Ionic, and Multiplatform. Each framework brings unique advantages, and selecting the most fitting one hinges on the specific needs of your project.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Cross-Platform App Development Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
